import { render, staticRenderFns } from "./ThirdcodeTable.vue?vue&type=template&id=7805eb50&scoped=true"
import script from "./ThirdcodeTable.vue?vue&type=script&lang=ts"
export * from "./ThirdcodeTable.vue?vue&type=script&lang=ts"
import style0 from "./ThirdcodeTable.vue?vue&type=style&index=0&id=7805eb50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7805eb50",
  null
  
)

export default component.exports